__turbopack_context__.v({
  "active": "AIMLTechStack-module__UMPkqa__active",
  "card": "AIMLTechStack-module__UMPkqa__card",
  "cat-dl": "AIMLTechStack-module__UMPkqa__cat-dl",
  "cat-genai": "AIMLTechStack-module__UMPkqa__cat-genai",
  "cat-libs": "AIMLTechStack-module__UMPkqa__cat-libs",
  "cat-mlops": "AIMLTechStack-module__UMPkqa__cat-mlops",
  "cat-nn": "AIMLTechStack-module__UMPkqa__cat-nn",
  "cat-toolkits": "AIMLTechStack-module__UMPkqa__cat-toolkits",
  "cat-vision": "AIMLTechStack-module__UMPkqa__cat-vision",
  "count": "AIMLTechStack-module__UMPkqa__count",
  "eyebrow": "AIMLTechStack-module__UMPkqa__eyebrow",
  "grid": "AIMLTechStack-module__UMPkqa__grid",
  "head": "AIMLTechStack-module__UMPkqa__head",
  "label": "AIMLTechStack-module__UMPkqa__label",
  "logo": "AIMLTechStack-module__UMPkqa__logo",
  "logoImg": "AIMLTechStack-module__UMPkqa__logoImg",
  "logoText": "AIMLTechStack-module__UMPkqa__logoText",
  "section": "AIMLTechStack-module__UMPkqa__section",
  "sub": "AIMLTechStack-module__UMPkqa__sub",
  "tab": "AIMLTechStack-module__UMPkqa__tab",
  "tabs": "AIMLTechStack-module__UMPkqa__tabs",
  "title": "AIMLTechStack-module__UMPkqa__title",
  "wrapper": "AIMLTechStack-module__UMPkqa__wrapper",
});
